<template>
  <div class="sq-player-wrap">
    <div
      :style="{width:width,height:height}"
      :class="{'kplayer': playerClass,'aplayer': !playerClass, 'video-center': isVideoCenter }"
      :ref="playerName"></div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'YPlayer',
  data() {
    return {
      options: {},
      yplayer:null
    };
  },
  props: {
    isReplay: {
      type: Boolean,
      default: true,
    },
    isVideoCenter: {
      type: Boolean,
      default: false,
    },
    immediate: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '522px',
    },
    height: {
      type: String,
      default: '295px',
    },
    playerName: {
      type: String,
      default: 'yplayer',
    },
    // options: {
    //   type: Object,
    //   default: {}
    // },
    customEventName: {
      type: String,
      default: 'statechanged',
    },
    events: {
      type: Array,
      default: () => [],
    },
    videoType: {
      type: String,
      default: '',
    },
    videoUrl: {
      type: String,
      default: '',
    },
    index:{
      type:Number,
      default:0
    }
  },
  methods: {
    closeVideo() {
      this.yplayer.closeVideo();
    },
    skipVideo() {
      this.yplayer.skipVideo();
    },
    fullScreenVideo() {
      this.yplayer.fullscreen();
    },
    seek(time){
      this.yplayer.seek(time)
    },
    initVideo() {
      this.$nextTick(() => {
        try {
          this.options = {
            container: document.getElementById('video_box'),
            preload: 'auto',
            autoplay: false,
            video: {
              url: this.videoUrl,
              pic: 'https://file1.classba.cn/homepage.png',
              // thumbnails: 'https://i.loli.net/2019/06/06/5cf8c5d9cec8510758.jpg',
            },
            theme: '#FDB550',
            setting: false,
            playbackRates: [1.5, 1.25, 1, 0.75], // speed
            vertical: true,
            pictureinpicture: false,
            fullscreen: {
              full: true,
              fullweb: false,
            },
            endpanel: {
              feedbackBtn: false,
              replayBtn: this.isReplay,
            },
            userInfo: {
              video_id: '',
              videoUrl: this.videoUrl,
            },
            socket: this.is_scocket,
            autoplay:this.index===0? true: false
          };
        } catch (e) {
        }
        const DEFAULT_EVENTS = [
          'loadeddata',
          'canplay',
          'canplaythrough',
          'play',
          'pause',
          'waiting',
          'playing',
          'ended',
          'error'
        ];
        const emitPlayerState = (event, value, player) => {
          if (event) {
            this.$emit(event, player);
          }
          if (value) {
            this.$emit(this.customEventName, { [event]: value });
          }
        };
        const self = this;
        this.options.container = this.$refs[`${this.playerName}`];
        this.yplayer = new window.YPlayer(this.options, function () {
          // events
          const events = DEFAULT_EVENTS.concat(self.events);
          // watch events
          const onEdEvents = {};
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < events.length; i++) {
            if (typeof events[i] === 'string' && onEdEvents[events[i]] === undefined) {
              ((event) => {
                onEdEvents[event] = null;
                this.on(event, () => {
                  emitPlayerState(event, true, this);
                });
              })(events[i]);
            }
          }
          self.$emit('ready', this);
        });
      });
    },
    getVideo() {
      return this.yplayer;
    },
  },
  created() {
  },
  mounted() {
    if (this.videoUrl) {
      this.initVideo();
    }

  },
  computed: {
    playerClass() {
      return this.playerName === 'knowledge';
    },
    getVideoUrl() {
      return this.videoUrl;
    },
  },
  // updated(){
  //   this.options.video.url = this.videoUrl
  // },
  watch: {
    videoUrl(newV, oldV) {
      console.log(newV, `--oldV${oldV}`);
      if (newV) {
        this.initVideo();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.sq-player-wrap {
  .video-center {
    margin: 0 auto;
  }
}
</style>
